import { API_ENDPOINT } from 'env'

const authHeaders = () => {
  const parsed = JSON.parse(localStorage.getItem('state'))
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${parsed.auth.token}` }
}

const handle = async (res) => {
  if (!res.ok) {
    const error = await res.json().catch(() => ({}))
    throw new Error(error.message || 'Erro na requisição')
  }
  return res.json()
}

export const getResgates = async (filtros = {}) => {
  const qs = new URLSearchParams(
    Object.entries(filtros).filter(([, v]) => v !== undefined && v !== '' && v !== null),
  ).toString()
  const res = await fetch(`${API_ENDPOINT}/resgates-lbc?${qs}`, { method: 'GET', headers: authHeaders() })
  return handle(res)
}

export const criarResgate = async (body) => {
  const res = await fetch(`${API_ENDPOINT}/resgates-lbc`, { method: 'post', headers: authHeaders(), body: JSON.stringify(body) })
  return handle(res)
}

export const alocarResgate = async (id, { unidadeId, quantidade }) => {
  const res = await fetch(`${API_ENDPOINT}/resgates-lbc/${id}/alocacao`, {
    method: 'put', headers: authHeaders(), body: JSON.stringify({ unidadeId, quantidade }),
  })
  return handle(res)
}

export const excluirResgate = async (id) => {
  const res = await fetch(`${API_ENDPOINT}/resgates-lbc/${id}`, { method: 'delete', headers: authHeaders() })
  return handle(res)
}

export const devolverSaldoResgate = async (id, quantidade) => {
  const res = await fetch(`${API_ENDPOINT}/resgates-lbc/${id}/devolver-saldo`, {
    method: 'post', headers: authHeaders(), body: JSON.stringify({ quantidade }),
  })
  return handle(res)
}

export const getTitulosResgataveis = async () => {
  const parsed = JSON.parse(localStorage.getItem('state'))
  const res = await fetch(`${API_ENDPOINT}/titulos-lbc?status=active`, {
    method: 'GET', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${parsed.auth.token}` },
  })
  if (!res.ok) throw new Error('Erro na requisição')
  const titulos = await res.json()
  return titulos.filter((t) => Number(t.quantidadeDisponivel) > 0)
}
